import React from 'react';
import { FormattedMessage } from 'react-intl';
import { List } from 'antd';

export default function PopoverText() {
  return (
    <div>
      <List>
        <List.Item>
          <FormattedMessage id={'Component.AccountSettings.New.PopoverText.AvailableRoles.Admin'} />
        </List.Item>
        <List.Item>
          <FormattedMessage id={'Component.AccountSettings.New.PopoverText.AvailableRoles.Editor'} />
          <br />
          <FormattedMessage id={'Component.AccountSettings.New.PopoverText.AvailableRoles.Editor.Span'} />
        </List.Item>
        <List.Item>
          <FormattedMessage id={'Component.AccountSettings.New.PopoverText.AvailableRoles.Viewer'} />
          <br />
          <FormattedMessage id={'Component.AccountSettings.New.PopoverText.AvailableRoles.Viewer.Span'} />
        </List.Item>
      </List>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Projects/PopoverText.js